import { gql } from '@apollo/client';

export interface WorkflowTemplateType {
    id: number;
    templateKey: string;
    name: string;
    bizType: string;
    version: number;
    status: number;
    definitionJson: string;
    description?: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface GetWorkflowLatestTemplateByBizTypeResponse {
    workflowLatestTemplateByBizType: WorkflowTemplateType | null;
}

export interface GetWorkflowLatestTemplateByBizTypeVariables {
    bizType: string;
}

export const GET_WORKFLOW_LATEST_TEMPLATE_BY_BIZ_TYPE = gql`
    query WorkflowLatestTemplateByBizType($bizType: String!) {
        workflowLatestTemplateByBizType(bizType: $bizType) {
            id
            templateKey
            name
            bizType
            version
            status
            definitionJson
            description
            createdAt
            updatedAt
        }
    }
`;

